import React from "react";
import ServiceHero from "../ServiceHero";
import Timeline from "../Timeline";
import BentoGrid from "../BentoGrid";
import FadeOnScroll from "../FadeOnScroll";

const softwareProcess = [
  { title: "Requirement Analysis", content: <p>Gathering business needs before we tackle the project together.</p> },
  { title: "System Design", content: <p>Creating scalable architecture.</p> },
  { title: "Development", content: <p>Building the solution collaboratively based on the given requirements, with room to manoeuvre through regular collaboration and feedback.</p> },
  { title: "Testing & Debugging", content: <p>Ensuring flawless performance.</p> },
  { title: "Deployment", content: <p>Making your software live.</p> },
  { title: "Ongoing Support", content: <p>Maintenance & improvements.</p> },
];

const softwareFeatures = [
  { title: "Custom Software", description: "Tailor-made applications.", image: "/assets/mobile-software.png", className: "col-span-1 lg:col-span-4 border-b lg:border-r" },
  { title: "Cloud Integration", description: "Seamless deployment and cloud solutions.", image: "/assets/cloud-software.png", className: "col-span-1 lg:col-span-2 border-b" },
  { title: "AI & Automation", description: "Harnessing existing and custom-made AI to help grow your business.", image: "/assets/ai-software.png", className: "col-span-1 lg:col-span-3 lg:border-r" },
  { title: "Existing Integration", description: "Provide you with the ability to build on existing applications.", image: "/assets/integration2-software.png", className: "col-span-1 lg:col-span-3 border-b" },
];

const Software = () => {
  return (
    <div className="w-full bg-[#f5f3eb] dark:bg-[#1c1c1c] min-h-screen">
      
      {/* Hero Section */}
      <FadeOnScroll>
        <ServiceHero 
          title="Software Solutions Tailored for You"
          description="Develop cutting-edge applications with our expert team."
          imageSrc="/assets/software-hero.png"
          lightCircleColor="#4B91C5"
          darkCircleColor="#3E70A0"
        />
      </FadeOnScroll>

      {/* Timeline Section */}
      <FadeOnScroll>
        <Timeline 
          title="Software Development Process"
          description="A step-by-step roadmap ensuring your software meets industry standards and is built to last."
          data={softwareProcess} 
        />
      </FadeOnScroll>

      {/* What We Offer Section */}
      <FadeOnScroll>
        <div className="relative z-20 py-10 lg:py-40 max-w-7xl mx-auto">
          <div className="px-8">
            <h4 className="text-3xl lg:text-5xl text-center font-medium text-black dark:text-white">
              What We Offer
            </h4>
          </div>
          <BentoGrid features={softwareFeatures} />
        </div>
      </FadeOnScroll>
      
    </div>
  );
};

export default Software;


